import type { ReactNode } from 'react';
import classnames from 'classnames';
import { IoFilterSharp } from 'react-icons/io5';

import style from '../style.module.scss';

interface MapTopBarProps {
    search: ReactNode;
    isRapidActive: boolean;
    isAvailabilityActive: boolean;
    isFilterDrawerOpen: boolean;
    onRapidToggle: () => void;
    onAvailabilityToggle: () => void;
    onFilterToggle: () => void;
}

const MapTopBar = ({
    search,
    isRapidActive,
    isAvailabilityActive,
    isFilterDrawerOpen,
    onRapidToggle,
    onAvailabilityToggle,
    onFilterToggle,
}: MapTopBarProps) => {
    return (
        <div className={style.mapTopBar}>
            {search}
            <span className={style.actionDivider} aria-hidden="true" />

            <button
                className={classnames(style.actionButton, isRapidActive && style.actionButtonActive)}
                type="button"
                onClick={onRapidToggle}
            >
                Încărcare rapidă
            </button>
            <button
                className={classnames(style.actionButton, isAvailabilityActive && style.actionButtonActive)}
                type="button"
                onClick={onAvailabilityToggle}
            >
                Disponibilitate
            </button>
            <span className={style.actionDivider} aria-hidden="true" />
            <button
                className={classnames(style.actionButtonLight, isFilterDrawerOpen && style.actionButtonLightActive)}
                type="button"
                onClick={onFilterToggle}
            >
                <IoFilterSharp fontSize={24} />
                Filtre
            </button>
        </div>
    );
};

export default MapTopBar;
